import styled from "styled-components";

export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 10px;
`;

export const AutoCompleteField = styled.div`
  margin-top: 10px;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
`;
